import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/DataTable/DataTable.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<DataTable
  title="Repositories"
  data={[
    {
      id: 1,
      name: 'codeql-dca-worker',
      type: 'internal',
      securityFeatures: {
        dependabot: ['alerts', 'security updates'],
      },
    },
    {
      id: 2,
      name: 'aegir',
      type: 'public',
      securityFeatures: {
        dependabot: ['alerts'],
      },
    },
    {
      id: 3,
      name: 'strapi',
      type: 'public',
      securityFeatures: {
        dependabot: [],
      },
    },
  ]}
  columns={[
    {
      header: 'Repository',
      field: 'name',
      rowHeader: true,
    },
    {
      header: 'Type',
      field: 'type',
      renderCell: row => {
        return <Label>{uppercase(row.type)}</Label>
      },
    },
    {
      header: 'Dependabot',
      renderCell: row => {
        return row.securityFeatures.dependabot.length > 0 ? (
          <LabelGroup>
            {row.securityFeatures.dependabot.map(feature => {
              return <Label key={feature}>{uppercase(feature)}</Label>
            })}
          </LabelGroup>
        ) : null
      },
    },
  ]}
/>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: false,
      noUnnecessaryDeps: false,
      adaptsToThemes: false,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      